// extracted by mini-css-extract-plugin
export var addViewLink = "_c-2";
export var availabilityIcon = "_c-17";
export var availabilitySelectionIcon = "_c-16";
export var backButton = "_c-3";
export var backIcon = "_c-10";
export var conversationCount = "_c-4";
export var dragHandle = "_c-6";
export var dropdown = "_c-f";
export var dropdownIcon = "_c-8";
export var dropdownOption = "_c-7";
export var dropdownTriangle = "_c-e";
export var expand = "_c-g";
export var folder = "_c-j";
export var folderItem = "_c-d";
export var icon = "_c-9";
export var iconRow = "_c-a";
export var image = "_c-b";
export var logo = "_c-c";
export var navContainer = "_c-i";
export var navigationFooter = "_c-h";
export var pageShell = "_c-0";
export var pageShellWms = "_c-1";
export var placeholderAvailable = "_c-12";
export var placeholderBox = "_c-15";
export var placeholderBusy = "_c-14";
export var placeholderUnavailable = "_c-13";
export var profile = "_c-l";
export var profileContainer = "_c-n";
export var profileDropdown = "_c-o";
export var profileImage = "_c-m";
export var profileMain = "_c-p";
export var profileSubtitle = "_c-r";
export var profileTitle = "_c-q";
export var reorderIcon = "_c-s";
export var sentLine = "_c-v";
export var settingsHeader = "_c-t";
export var sidenavTextColor = "_c-z";
export var spamLine = "_c-u";
export var subitemWithTag = "_c-5";
export var supportItems = "_c-k";
export var teamText = "_c-11";
export var viewLine = "_c-y";
export var viewLineButton = "_c-x";
export var viewLineButtons = "_c-w";